// Shared by the header's range control and the page subtitle. Labels are
// deliberately shaped like the ones in stores/analytics.js — a short pill label
// and a long form for the mobile select — so the Tasks header reads identically
// to the Bookings and Traffic ones.
export const TASK_STAT_RANGES = [
  { value: '7d',     label: '7d',     long: 'Last 7 days' },
  { value: '30d',    label: '30d',    long: 'Last 30 days' },
  { value: '90d',    label: '90d',    long: 'Last 90 days' },
  { value: '12m',    label: '12m',    long: 'Last 12 months' },
  { value: 'custom', label: 'Custom', long: 'Custom range' },
]

// The subtitle under the page title. Bookings and Traffic get theirs from the
// server payload; the task stats payload carries only machine dates, so the
// window is described from the filters instead.
export function taskRangeLabel(filters) {
  if (!filters) return ''
  if (filters.range === 'custom') {
    if (!filters.startDate || !filters.endDate) return 'Custom range'
    return `${filters.startDate} to ${filters.endDate}`
  }
  return TASK_STAT_RANGES.find(r => r.value === filters.range)?.long ?? ''
}
